<template>
    <div>
        <card-header title="Announcements" icon="fa-bullhorn"/>
        <card-toolbar>
            <button @click="$openCard('edit-announcement', {tripId: props.tripId}, card)"><i class="fas fa-plus mr-2"/>New Announcement</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <announcement-list-item
                    v-for="post in posts"
                    :key="post.id"
                    :card="card"
                    :post="post"
                    :active="(child && child.definition.component === 'edit-announcement') && child.props && Number(child.props.postId) === post.id"
                    @click="$openCard('edit-announcement', {tripId: props.tripId, postId: post.id}, card)"
                />

                <container-list-item padded v-if="!posts.length && !loading">
                    <p class="has-text-grey is-italic">No announcements for this trip yet.</p>
                </container-list-item>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardList from "@/TIER/components/CardList";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import AnnouncementListItem from "@/components/AnnouncementListItem";

    import {client as http} from '@/http_client';

    export default {
        name: "TripAnnouncements",
        props: ['card', 'child', 'props'],
        components: {AnnouncementListItem, ContainerListItem, CardList, CardToolbar, CardBody, CardHeader},
        data: function() {
            return {
                posts: [],
                loading: true
            };
        },
        methods: {
            load: function(force) {
                this.$emit('loading', true);
                http.get('/api/experience/trips/' + this.props.tripId + '/announcements?limit=50', {force}).then(response => {
                    this.posts = response.data.posts;
                    this.loading = false;
                    this.$emit('loading', false);
                });
            },
            reload: function() {
                this.load(true);
            }
        },
        mounted() {
            this.load(true);
        }
    };
</script>

<style lang="scss" scoped>
</style>
